"use client"

import { LampWallDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LampWallDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LampWallDownIcon = component(Icon)({ as: LampWallDown })
